var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38368",
    "data-name": "Group 38368",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.793,
    height: 33.718,
    viewBox: "0 0 35.793 33.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.845,0l8.948,16.859L26.845,33.718H8.948L0,16.859,8.948,0Z",
    transform: "translate(0 0)",
    fill: "#78a574"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Education_1_copy_3",
    "data-name": "Education_1 copy 3",
    transform: "translate(9.345 9.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64986",
    "data-name": "Path 64986",
    d: "M82.616,142.83a7.753,7.753,0,0,0-.373-2.191l-.016-.049h-.049a18.5,18.5,0,0,0-8.519,1.525,15.182,15.182,0,0,1,8.146-2.3h.1l-.049-.081a7.738,7.738,0,0,0-1.3-1.9l-.032-.032-.032.016a20.415,20.415,0,0,0-7.627,4.544.588.588,0,0,1-.811,0,20.415,20.415,0,0,0-7.627-4.544l-.032-.016-.032.032a9.165,9.165,0,0,0-1.3,1.9l-.049.081h.1a15.365,15.365,0,0,1,8.146,2.3,18.5,18.5,0,0,0-8.519-1.525h-.049l-.016.049a6.754,6.754,0,0,0-.373,2.191v.065h.065a17.112,17.112,0,0,0,3.716-.341,11.957,11.957,0,0,1,5.1-.081.3.3,0,0,1,.227.292.256.256,0,0,0,.26.26h1.59a.256.256,0,0,0,.26-.26.312.312,0,0,1,.227-.292,11.957,11.957,0,0,1,5.1.081,18.294,18.294,0,0,0,3.716.341h.065Z",
    transform: "translate(-62.3 -128.421)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64987",
    "data-name": "Path 64987",
    d: "M77.132,87.221a19.879,19.879,0,0,1,4.657,2.5,19.5,19.5,0,0,1,4.641-2.5V84.9a.429.429,0,0,0-.211-.373,9.4,9.4,0,0,0-4.43-.8,10.761,10.761,0,0,0-4.057.617,10.039,10.039,0,0,1,4.722-.876c2.9,0,4.349.454,4.349,1.314v.682l3.359-1.574L81.773,80,73.4,83.895l3.716,1.72v1.606Z",
    transform: "translate(-71.599 -80)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentIcon);
export default __webpack_public_path__ + "static/media/studentIcon.ac60ffdcf59305266f26d528d925b1d9.svg";
export { ForwardRef as ReactComponent };